import React from 'react'
import Image from 'next/image'

import TryFreeCta from '@/components/TryFreeCta'
import BuyNowCta from '@/components/BuyNowCta'
import { Text, ButtonGroup } from '@/components/common'
import { Column, Layout, Row, Rows, Section } from '@/components/layout'
import id2Img from '@/assets/tax-prep/id2.png'
import transactionStreamImg from '@/assets/transaction-streaming/transaction-stream.png'
import organiseFilesImg from '@/assets/features-potential/organise-files.jpg'
import connectAccount from '@/assets/automated-insights/connect-account.png'
import scansnapIntegration from '@/assets/scansnap-cloud/scansnap-integration.png'
import scansnapScanner from '@/assets/scansnap-cloud/scansnap-scanner.jpg'
import scansnapSave from '@/assets/scansnap-cloud/scansnap-save.jpg'
import pairReceipts from '@/assets/scansnap-cloud/pair-receipts.jpg'
import accountingReports from '@/assets/scansnap-cloud/accounting-reports.jpg'
import realTimeInsights from '@/assets/scansnap-cloud/real-time-insights.jpg'
import customInvoices from '@/assets/scansnap-cloud/custom-invoices.jpg'

import styles from './scansnap-cloud.module.scss'

const pageId = 'scansnapCloud'

export default function ScansnapCloud() {
  return (
    <Layout.Content>
      <Section>
        <Column className={styles.headerSection}>
          <div className={styles.heroContent}>
            <div>
              <Image alt="Stream Account Transactions" src={scansnapIntegration} style={{ height: 'auto' }} />
              <Text.P>
                Declutter, increase efficiency, and gain peace of mind by combining the simple & reliable scanning
                performance of ScanSnap with smart file organization & efficient expense management of Neat.
              </Text.P>
            </div>
          </div>
          <Image alt="Stream Account Transactions" src={scansnapSave} style={{ height: 'auto' }} />
        </Column>
      </Section>

      <Section center>
        <Text.H2 center className="max-w-600">Power up your ScanSnap scanner with the organization of Neat</Text.H2>
        <ButtonGroup className={styles.ctaButtons}>
          <BuyNowCta
            messageId="cta.buyNow"
            style={{ border: '0' }}
          />
          <TryFreeCta messageId="cta.tryNeatTrial" />
        </ButtonGroup>
        <Text.P center>Neat is a yearly subscription with a <span className="c-brand">30 Day Money back guarantee</span></Text.P>
      </Section>

      <div className={styles.textImageSection}>
        <Section>
          <Rows gap={0}>
            <Row center textCenter>
              <h2 className="c-brand">
                Our Neat Base Plan Features for Smart File Organization
              </h2>
            </Row>
          </Rows>
        </Section>

        <Section paddingTop={0}>
          <Row>
            <Column center size={50}>
              <Image
                alt="Track Documents Everywhere"
                className={styles.dataExtractImg}
                src={scansnapScanner}
                style={{ height: 'auto' }}
              />
            </Column>
            <Column center size={50}>
              <Rows className="w-full">
                <Text.H2>Track Documents Everywhere</Text.H2>
                <Text.P>Capture documents, receipts, invoices, and so much more when scanning with your ScanSnap.
                  Then upload them straight to Neat using the app. Even email, drag and drop documents into Neat,
                  or import with the perfect ScanSnap scanner.
                </Text.P>
                <Text.P>You’ll always have access to your documents in Neat.</Text.P>
              </Rows>
            </Column>
          </Row>
        </Section>

        <Section paddingTop={0}>
          <Row>
            <Column center className={styles.textSection} size={50}>
              <Rows className="w-full">
                <Text.H2>Data Extraction</Text.H2>
                <Text.P>Reduce manual data entry with Neat’s powerful, patented OCR technology that accurately
                  extracts key information from your document and turns it into usable data allowing you to enter
                  receipts quickly and accurately.
                </Text.P>
              </Rows>
            </Column>
            <Column center className={styles.imgSection} size={50}>
              <Image alt="Data Extraction" className={styles.dataExtractImg} src={id2Img} style={{ height: 'auto' }} />
            </Column>
          </Row>
        </Section>

        <Section paddingTop={0}>
          <Row>
            <Column center size={50}>
              <Image alt="Data Verification" src={transactionStreamImg} style={{ height: 'auto' }} />
            </Column>
            <Column center size={50}>
              <Rows className="w-full">
                <Text.H2>Data Verification</Text.H2>
                <p>Your receipt items are processed using Neat’s unique data identification technology and data is
                  extracted with 99% accuracy.
                </p>
              </Rows>
            </Column>
          </Row>
        </Section>

        <Section paddingTop={0}>
          <Row>
            <Column center className={styles.textSection} size={50}>
              <Rows className="w-full">
                <Text.H2>Organize Files Your Way</Text.H2>
                <Text.P>Organize files by expense type, tax category, and more. Quickly find files with our keyword
                  search and filtering capabilities.
                </Text.P>
              </Rows>
            </Column>
            <Column center className={styles.imgSection} size={50}>
              <Image alt="Organise files" src={organiseFilesImg} style={{ height: 'auto' }} />
            </Column>
          </Row>
        </Section>
      </div>

      <Section className="max-w-600">
        <Text.H2 center>Power up your ScanSnap scanner with the organization of Neat</Text.H2>
        <ButtonGroup className={styles.ctaButtons}>
          <BuyNowCta
            messageId="cta.buyNow"
            style={{ border: '0' }}
          />
          <TryFreeCta messageId="cta.tryNeatTrial" />
        </ButtonGroup>
        <Text.P center>Neat is a yearly subscription with a <span className="c-brand">30 Day Money back guarantee</span></Text.P>
      </Section>

      <Section>
        <Rows gap={0}>
          <Row center textCenter>
            <h2 className="c-brand">Our Automated Insights Plan Provides Financial Reporting</h2>
          </Row>
        </Rows>
      </Section>

      <div className={styles.textImageSection}>
        <Section paddingTop={0}>
          <Row>
            <Column center size={50}>
              <Image
                alt="Connect Bank Account"
                className={styles.dataExtractImg}
                src={connectAccount}
                style={{ height: 'auto' }}
              />
            </Column>
            <Column center size={50}>
              <Rows className="w-full">
                <Text.H2>Connect Bank Account</Text.H2>
                <Text.P>Manage all of your financial data in one place by importing all of your
                  bank account(s) activity.
                </Text.P>
              </Rows>
            </Column>
          </Row>
        </Section>

        <Section paddingTop={0}>
          <Row>
            <Column center className={styles.textSection} size={50}>
              <Rows className="w-full">
                <Text.H2>Pair receipts with expenses</Text.H2>
                <Text.P>With your ScanSnap scanner upload and match receipts to expenses as they occur.
                  Guided workflows are provided with suggested receipt matching to make accounting easy.
                </Text.P>
              </Rows>
            </Column>
            <Column center className={styles.imgSection} size={50}>
              <Image alt="Organise files" src={pairReceipts} style={{ height: 'auto' }} />
            </Column>
          </Row>
        </Section>

        <Section paddingTop={0}>
          <Row>
            <Column center size={50}>
              <Image
                alt="Accounting Reports"
                className={styles.dataExtractImg}
                src={accountingReports}
                style={{ height: 'auto' }}
              />
            </Column>
            <Column center size={50}>
              <Rows className="w-full">
                <Text.H2>Accounting Reports</Text.H2>
                <Text.P>Make informed decisions with automatic, real-time accounting reports such as profit and loss
                  statements, cash flow statements, balance sheets, and transaction reports.
                </Text.P>
                <Text.P>Download and share reports with anyone who may need to view it for accounting or record
                  keeping purposes.
                </Text.P>
              </Rows>
            </Column>
          </Row>
        </Section>

        <Section paddingTop={0}>
          <Row>
            <Column center className={styles.textSection} size={50}>
              <Rows className="w-full">
                <Text.H2>Real-time insights</Text.H2>
                <Text.P>Know what is going on in your business at a glance, with real-time insights - including
                  net cash flow, top expense categories, cash balance, profit and loss, and total sales.
                </Text.P>
              </Rows>
            </Column>
            <Column center className={styles.imgSection} size={50}>
              <Image alt="Real-time insights" src={realTimeInsights} style={{ height: 'auto' }} />
            </Column>
          </Row>
        </Section>

        <Section paddingTop={0}>
          <Row>
            <Column center size={50}>
              <Image
                alt="Custom Invoices"
                className={styles.dataExtractImg}
                src={customInvoices}
                style={{ height: 'auto' }}
              />
            </Column>
            <Column center size={50}>
              <Rows className="w-full">
                <Text.H2>Custom Invoices</Text.H2>
                <Text.P>Send customized invoices within minutes.</Text.P>
              </Rows>
            </Column>
          </Row>
        </Section>
      </div>

      <Section className="max-w-600">
        <Text.H2 center>Power up your ScanSnap scanner with the organization of Neat</Text.H2>
        <ButtonGroup className={styles.ctaButtons}>
          <BuyNowCta
            messageId="cta.buyNow"
            style={{ border: '0' }}
          />
          <TryFreeCta messageId="cta.tryNeatTrial" />
        </ButtonGroup>
        <Text.P center>Neat is a yearly subscription with a <span className="c-brand">30 Day Money back guarantee</span></Text.P>
      </Section>

    </Layout.Content>
  )
}

ScansnapCloud.layoutProps = {
  pageId,
}
